<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        class="lds-equalizer"
        viewBox="0 0 100 100"
        preserveAspectRatio="xMidYMid"
        :class="className"
    >
        <g transform="rotate(180 50 50)">
            <rect y="36" height="24.0108" fill="#e15b64" :x="7.6923076923076925 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.5833333333333334s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="28.4181" fill="#f47e60" :x="15.384615384615385 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.6666666666666666s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="8.11305" fill="#f8b26a" :x="23.076923076923077 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="0s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="29.9656" fill="#abbd81" :x="30.76923076923077 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.75s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="4.08943" fill="#849b87" :x="38.46153846153846 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.08333333333333333s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="10.4173" fill="#e15b64" :x="46.15384615384615 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.25s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="19.945" fill="#f47e60" :x="53.84615384615385 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.4166666666666667s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="28.3615" fill="#f8b26a" :x="61.53846153846154 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.8333333333333334s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="5.00829" fill="#abbd81" :x="69.23076923076923 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.16666666666666666s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="20.6302" fill="#849b87" :x="76.92307692307692 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.5s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="17.4689" fill="#e15b64" :x="84.61538461538461 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.3333333333333333s"
                    :dur="speed"
                ></animate>
            </rect>
            <rect y="36" height="19.572" fill="#f47e60" :x="92.3076923076923 - width / 2" :width="width">
                <animate
                    attributeName="height"
                    calcMode="spline"
                    values="20;30;4;20"
                    times="0;0.33;0.66;1"
                    keySplines="0.5 0 0.5 1;0.5 0 0.5 1;0.5 0 0.5 1"
                    repeatCount="indefinite"
                    begin="-0.9166666666666666s"
                    :dur="speed"
                ></animate>
            </rect>
        </g>
    </svg>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "BarSpinner",
    props: {
        width: {
            type: Number,
            default: 6,
        },
        speed: {
            type: Number,
            default: 1,
        },
        className: {
            type: String,
            default: "",
        },
    },
});
</script>

<style scoped lang="scss">
svg {
    width: 20px;
    height: 20px;
}
</style>
